import { ProfiBazaAPIModels } from 'services/src/profiBazaAPI';

export const mappings = new Map<ProfiBazaAPIModels.RoleType, string>([
	[ProfiBazaAPIModels.RoleType.ADMIN, 'administracyjna'],
	[ProfiBazaAPIModels.RoleType.USER, 'zwykła'],
]);

export const map = (value: ProfiBazaAPIModels.RoleType): string =>
	mappings.get(value) ?? '';
